import { ajaxSend } from 'api/api';
const BASE_PATH = '/v1/numbers';
const AVAILABLE_NUMBERS_PATH = '/v1/available-numbers';
export class TelephonyAPI {
    getPhoneNumbers(query) {
        var _a;
        const isPathParameterPassed = !!query.path;
        const params = new URLSearchParams();
        if (!isPathParameterPassed) {
            const { limit, count, after, before, search } = query;
            if (limit) {
                params.set('limit', limit);
            }
            if (count) {
                params.set('count', count);
            }
            if (after) {
                params.set('after', encodeURIComponent(after));
            }
            if (before) {
                params.set('before', encodeURIComponent(before));
            }
            if (search) {
                params.set('search', search);
            }
        }
        return ajaxSend({
            path: (_a = query.path) !== null && _a !== void 0 ? _a : `${BASE_PATH}?${params.toString()}`,
        });
    }
    searchNumbers(query) {
        var _a, _b;
        const { country, type, next_page, prev_page } = query;
        const countryCode = (_a = country === null || country === void 0 ? void 0 : country.country_code) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        const params = new URLSearchParams();
        if (type) {
            params.set('numbers_type', type);
        }
        return ajaxSend({
            path: (_b = next_page !== null && next_page !== void 0 ? next_page : prev_page) !== null && _b !== void 0 ? _b : `${AVAILABLE_NUMBERS_PATH}/${countryCode}?${params.toString()}`,
        });
    }
    releaseNumber(number) {
        const { e164_format } = number;
        return ajaxSend({
            path: `${BASE_PATH}/${e164_format}`,
            method: 'DELETE',
        });
    }
    updateNumber(query) {
        const { number, name, record_outbound_calls } = query;
        return ajaxSend({
            path: `${BASE_PATH}/${number}`,
            method: 'PUT',
            data: {
                name,
                record_outbound_calls,
            },
        });
    }
    buyNumber(query) {
        const { number, name } = query;
        const { phone_number: { e164_format }, } = number;
        return ajaxSend({
            path: BASE_PATH,
            method: 'POST',
            data: {
                phone_number: {
                    e164_format,
                },
                name,
            },
        });
    }
    buyGroup(query) {
        const { group, name } = query;
        const { group_id } = group;
        return ajaxSend({
            path: BASE_PATH,
            method: 'POST',
            data: {
                group: {
                    group_id,
                },
                name,
            },
        });
    }
}
export default new TelephonyAPI();
